import { Box } from "../mantine-passthroughs/index.js";
import { ContainerItem } from "./ContainerItem.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/container/Container.tsx
const Container = ({ children, className, name, type = "size", "data-testid": testId }) => {
	const style = { containerType: type };
	if (name) style.containerName = name;
	if (className) return /* @__PURE__ */ jsx(Box, {
		style,
		"data-testid": testId,
		children: /* @__PURE__ */ jsx(ContainerItem, {
			className,
			children
		})
	});
	return /* @__PURE__ */ jsx(Box, {
		style,
		"data-testid": testId,
		children
	});
};

//#endregion
export { Container };